import type {Result, UseCase} from 'framework';
import type {ScheduleError} from '../../domain/errors';
import type {ScheduleOneOffId} from '../../domain/schedule-one-off-id.value-object';
import type {ScheduleRepository} from '../ports/schedule.repository';

export class RemoveScheduleOneOff implements UseCase<[ScheduleOneOffId], void> {
  constructor(private readonly repository: ScheduleRepository) {}

  execute(oneOffId: ScheduleOneOffId): Promise<Result<void, ScheduleError>> {
    return this.repository.removeOneOff(oneOffId);
  }
}
